import React, { createElement, useEffect, useRef, useState } from 'react';
import { Button, Icon, Table, Message, Loading, Overlay, Balloon } from '@alifd/next';
import { previewDataByField } from '../../../api/common/index';
import { dealOrderByBoList, dealArray, dealFieldByList, getTextWidth, dom2image, getSearchType, dealSymbol, } from '../../../utils';
import './index.scss';
import TableHeader from './TableHeader';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
import { exportExcel, fIsMobile } from '../../../utils';
import { fetchApplication } from '../../../api/report';
const { Popup } = Overlay;
const Tooltip = Balloon.Tooltip;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const appid = urlParams.get('applicationId');
const IMultiTable = (props, ref) => {
    const { dataSource, cols, theme, colWidth = [], fixedColumnlndex = 0, headerBgColor, headerTextColor, hasTitle, titleText, descText, } = props;
    const data = props.data;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [idata, setIdata] = useState([]);
    const [icols, setIcols] = useState([]);
    const [sum, setSum] = useState(null);
    const [loading, setLoading] = useState(false);
    const popcell = (text, width) => {
        const popupProps = {
            animation: {
                in: 'zoomIn',
                out: 'zoomOut',
            },
            triggerType: 'hover',
            placementOffset: 4,
        };
        const w = getTextWidth(text) + 32;
        if (w > Number(width?.replace('px', ''))) {
            return (createElement(Popup, Object.assign({}, popupProps, { v2: true, trigger: createElement("div", { className: "popcell" }, text), placement: "t" }),
                createElement("div", { className: "popup" }, text)));
        }
        return text;
    };
    const renderCols = () => {
        return icols.map((col, index) => {
            return (createElement(Table.Column, Object.assign({}, col, { key: col?.dataIndex, cell: (text) => popcell(text, col?.width || '200px') }, (fixedColumnlndex > index
                ? {
                    lock: 'left',
                }
                : {}))));
        });
    };
    useEffect(() => {
        try {
            const sum = {};
            icols.forEach((item, index) => {
                if (index) {
                    sum[item.dataIndex] = idata.reduce((accumulator, currentItem) => {
                        const sum = parseFloat((accumulator + currentItem[item.dataIndex]).toFixed(4));
                        return sum;
                    }, 0);
                }
                else {
                    sum[item.dataIndex] = '总计:';
                }
            });
            setSum(sum);
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('总计项计算出错,请在数据源面板重新配置过滤字段或更新组件');
        }
    }, [idata]);
    useEffect(() => {
        setError(false);
        try {
            init();
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('初始化数据出错,请在数据源面板重新配置字段或更新组件');
        }
    }, [dataSource]);
    const highlights = [];
    const getComputedStyle = (rowIndex, colIndex, dataIndex, record) => {
        try {
            let bgc = {};
            const find = highlights.find((e) => e.props === dataIndex);
            if (find) {
                if (record[dataIndex] > find.threshold) {
                    bgc = {
                        style: {
                            backgroundColor: find.color,
                        },
                    };
                }
            }
            return {
                ...bgc,
            };
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('单元格样式计算异常,请更新组件');
        }
    };
    const init = (param = false) => {
        try {
            if (dataSource?.x?.length && dataSource?.y?.length && dataSource?.c?.length) {
                const fl = dataSource?.filter || [];
                const params = {
                    groupId: dataSource?.dataset.id,
                    searchType: 'EXPORT',
                    type: 'MultiTable',
                    fieldList: dealFieldByList([...dataSource.x, ...dataSource.y, ...dataSource.c]),
                    horizontalAxis: dealOrderByBoList(dataSource?.x),
                    longitudinalAxis: dealOrderByBoList(dataSource?.c),
                    groupAxis: dealArray(dataSource.y),
                    customFilterVo: param
                        ? {
                            logic: 'and',
                            filterVos: [
                                dataSource?.filter[0],
                                ...Object.entries(param).map((item) => {
                                    const [name, value] = item;
                                    const field = dataSource.f.find((e) => e.name === name);
                                    if (value != undefined && value != '' && String(value) !== ',') {
                                        return {
                                            filed: field?.fieldShortName,
                                            filterValue: String(value),
                                            customFilterVo: String(value),
                                            symbol: dealSymbol(field?.additional?.relationship, field?.additional?.searchType || 'fuzzyQuery'),
                                            valueType: field?.type,
                                            filterType: getSearchType(field?.additional?.searchType || 'fuzzyQuery'),
                                        };
                                    }
                                }),
                            ].filter((e) => e && e.filterValue),
                        }
                        : fl[0] === undefined
                            ? null
                            : {
                                logic: 'and',
                                filterVos: [dataSource?.filter[0] || null].filter((e) => e),
                            },
                };
                previewDataByField(params)
                    .then((res) => {
                    const fields = res?.data?.fields;
                    if (!fields) {
                        Message.error(res?.msg);
                        return;
                    }
                    const xw = dataSource.x[0];
                    const yw = dataSource.y[0];
                    const vw = dataSource.c[0];
                    const types = {
                        title: xw.name,
                        dataIndex: 'uu_type',
                        width: `${colWidth[0] || 100}px`,
                        checked: true,
                    };
                    let rows;
                    if (dataSource.x[0]?.additional?.sort) {
                        rows = dataSource.x[0]?.additional?.sort.map((e) => e) || [];
                    }
                    else {
                        rows = Array.from(new Set(res.data.horizontalData.data.map((e) => ({
                            name: e[xw.fieldShortName],
                            checked: true,
                        }))));
                    }
                    let titles;
                    if (dataSource.y[0]?.additional?.sort) {
                        titles = dataSource.y[0]?.additional?.sort.map((e) => e) || [];
                    }
                    else {
                        titles = Array.from(new Set(res.data.groupData.data.map((e) => ({
                            name: e[yw.fieldShortName],
                            checked: true,
                        }))));
                    }
                    const tdata = [];
                    rows.forEach((item) => {
                        const line = {};
                        line['uu_type'] = item?.name;
                        line.checked = item.checked;
                        titles.forEach((itm) => {
                            const one = res.data.data.find((e) => e[xw.fieldShortName] === item?.name && e[yw.fieldShortName] === itm?.name);
                            if (one) {
                                line[itm.name] = Number(one[vw.fieldShortName]);
                            }
                            else {
                                line[itm.name] = 0;
                            }
                        });
                        tdata.push(line);
                    });
                    const minw = 50;
                    const maxw = 400;
                    const tempCols = titles.map((e, index) => {
                        const list = [
                            e?.additional?.alias || e.name,
                            ...res.data.data.map((item) => item[e.fieldShortName]),
                        ];
                        let width = minw;
                        for (let i = 0; i < list.length; i++) {
                            const w = getTextWidth(list[i]) + 36;
                            if (width < w) {
                                width = Math.min(w, maxw);
                                if (width === 400)
                                    break;
                            }
                        }
                        return {
                            title: e?.name,
                            dataIndex: e?.name,
                            width: `${width}px`,
                            checked: e.checked,
                        };
                    });
                    const rcols = [types, ...tempCols];
                    const rdata = tdata;
                    setIcols(rcols);
                    setIdata(rdata);
                })
                    .finally(() => {
                    setLoading(false);
                });
            }
            else {
                const rdata = data;
                setIcols(cols);
                setIdata(rdata);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('初始化数据出错,请在数据源面板重新配置字段或更新组件');
        }
    };
    const filterSearch = (param) => {
        try {
            if (dataSource?.x?.length && dataSource?.y?.length && dataSource?.c?.length) {
                setLoading(true);
                init(param);
            }
            else {
                Message.show('暂无可查询数据!');
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('过滤查询出错,请更新数据源面板字段或更新组件');
        }
    };
    const filterReset = () => {
        try {
            init();
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('查询重置出错,请更新数据源面板字段或更新组件');
        }
    };
    const exporter = useRef();
    const exportImage = () => {
        setLoading(true);
        setTimeout(() => {
            dom2image(exporter.current, `${titleText || dataSource?.dataset?.name || '统计表格'}_${new Date().toLocaleString()}.png`).finally(() => {
                setLoading(false);
            });
        }, 40);
    };
    const [isMoble, setIsMoble] = useState(fIsMobile());
    const listenResize = () => {
        setIsMoble(fIsMobile());
    };
    useEffect(() => {
        window.addEventListener('resize', listenResize);
        return () => {
            window.removeEventListener('resize', listenResize);
        };
    }, []);
    const myExportExcel = async () => {
        const reslut = await fetchApplication(appid);
        const title = reslut.data.applicationName;
        exportExcel([...idata, sum], icols, `${title}_统计表格`);
    };
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement("div", { ref: ref, className: `table-${props.size} base_bg multi_table` },
        createElement("div", { className: "flex-b" },
            hasTitle && dataSource?.dataset?.name ? (createElement("div", { className: "flex-s datasettitle" },
                createElement("div", null, titleText || dataSource?.dataset?.name),
                createElement(Tooltip, { v2: true, popupStyle: {
                        backgroundColor: '#1F2633',
                        color: '#fff',
                        borderRadius: '8px',
                    }, trigger: createElement("img", { style: { marginLeft: '8px' }, src: require('../../../assets/images/help.png'), alt: "" }) }, descText || '暂未配置描述'))) : (createElement("div", null)),
            isMoble ? null : (createElement("div", { className: "table_header" },
                createElement(Button, { className: "export_btn", onClick: myExportExcel, type: "normal" },
                    createElement(Icon, { type: "download" }),
                    "\u5BFC\u51FA"),
                createElement(Button, { className: "export_btn img_btn", onClick: exportImage, type: "normal" },
                    createElement(Icon, { type: "download" }),
                    "\u5BFC\u51FA\u56FE\u7247")))),
        createElement(Loading, { visible: loading, fullScreen: true },
            createElement(TableHeader, { sum: sum, dataset: dataSource?.dataset || null, field: dataSource?.f, filterSearch: filterSearch, filterReset: filterReset, data: idata, cols: icols, setError: setError, setErrmsg: setErrmsg, exportImage: exportImage, appid: appid }),
            createElement("div", { ref: exporter },
                createElement(Table.StickyLock, { dataSource: sum ? [...idata, sum] : idata, fixedHeader: props.fixedHeader, maxBodyHeight: props.maxBodyHeight, hasBorder: theme === 'border', isZebra: theme === 'zebra', cellProps: getComputedStyle, className: `${theme === 'noBorder' ? 'noBorder' : ''}`, style: {
                        '--hbgc': headerBgColor || '#E4E7ED',
                        '--htc': headerTextColor || '#444',
                    } }, renderCols())))))));
};
export default React.forwardRef(IMultiTable);
